module.exports = __webpack_public_path__ + "img/2-4.7715b29e.png";